import React, { useState, useEffect } from 'react';
import { SetupDefaultModal } from './default-questionnaire-modals';

interface DefaultQuestionnaireBannerProps {
  show: boolean;
  onSetDefault: () => void;
}

const DefaultQuestionnaireBanner: React.FC<DefaultQuestionnaireBannerProps> = ({
  show,
  onSetDefault,
}) => {
  const [bannerVisible, setBannerVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [showSetupModal, setShowSetupModal] = useState(false);

  useEffect(() => {
    if (show) {
      setShouldRender(true);
      const timer = setTimeout(() => setBannerVisible(true), 1000);
      return () => clearTimeout(timer);
    } else {
      // Start exit animation
      setBannerVisible(false);
      // Keep in DOM until exit animation completes
      const exitTimer = setTimeout(() => setShouldRender(false), 700);
      return () => clearTimeout(exitTimer);
    }
  }, [show]);

  if (!shouldRender) return null;

  return (
  <>
    <div
      style={{
        maxHeight: bannerVisible ? '90px' : '0px',
        marginBottom: bannerVisible ? '0.5rem' : '0px',
        opacity: bannerVisible ? 1 : 0,
        transform: bannerVisible ? 'translateY(0)' : 'translateY(-20px)',
        transition:
          'max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#E1FBFA',
          border: '1px solid #11807A',
          borderRadius: '12px',
          padding: '16px 16px',
          marginBottom: '1rem',
          boxShadow: '0 4px 8px rgba(173, 181, 189, 0.15), 0 2px 4px rgba(173, 181, 189, 0.3)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginLeft: '8px',
          }}
        >
          <i
            className="far fa-file-check"
            style={{ fontSize: '1.5rem', color: '#11807A' }}
          ></i>
          <span style={{ color: '#11807A', fontWeight: 500 }}>
            <b>Set your default questionnaire:</b> Pick your go-to questionnaire once, and it will apply automatically to all future jobs!
          </span>
        </div>
        <button
          onClick={() => setShowSetupModal(true)}
          style={{
            backgroundColor: '#FFFFFF',
            color: '#11807A',
            border: '1px solid #11807A',
            borderRadius: '4px',
            padding: '8px 12px',
            fontWeight: 400,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition:
              'background-color 0.5s ease, color 0.5s ease, border-color 0.5s ease, box-shadow 0.5s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#11807A';
            e.currentTarget.style.color = '#FFFFFF';
            e.currentTarget.style.borderColor = '#11807A';
            e.currentTarget.style.boxShadow =
              '0 2px 8px rgba(25, 162, 36, 0.14)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#FFFFFF';
            e.currentTarget.style.color = '#11807A';
            e.currentTarget.style.borderColor = '#11807A';
            e.currentTarget.style.boxShadow = 'none';
          }}
          id="btn-defaultq-setupnow"
        >
          Set up Now!
        </button>
      </div>
    </div>

    <SetupDefaultModal
      isOpen={showSetupModal}
      onClose={() => setShowSetupModal(false)}
    />
  </>
  );
};

export default DefaultQuestionnaireBanner;
